import styled from 'styled-components';
import { breakpoints } from 'config/config';
import { Drawer } from 'antd';

export const StyledOrdersDrawer = styled(Drawer)`
  .order-content {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .order-items-table-wrapper {
    padding-top: 10px;
    border-top: 1px solid ${(props) => props.theme.inputAddonBg};
  }

  .ant-btn {
    border-radius: 3px;
  }

  tbody tr:nth-child(2n) td {
    background-color: ${(props) => props.theme.white};
  }

  .content-invoice {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 20px;
  }

  .ant-drawer-header {
    min-height: 113px;

    .ant-drawer-header-title {
      display: flex;
      flex-direction: row-reverse;
    }
    .ant-drawer-close {
      color: ${(props) => props.theme.black};
    }
  }

  .footer-container {
    display: flex;
    gap: 5px;
    justify-content: flex-end;
  }

  .custom-header {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .payment-status-tag {
    margin-left: 10px;
    background-color: ${(props) => props.theme.paymentStatusPaid} !important;
    color: ${(props) => props.theme.white} !important;
    border-radius: 15px;
    border: none;
    font-weight: 400;
    padding: 0px 10px;
  }

  .product-selector-wrapper {
    display: flex;
    gap: 10px;
    margin-top: 10px;
    padding: 10px;
    background-color: ${(props) => props.theme.lightGray};
    border-radius: 4px;
  }

  .add-product-button-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 15px;
    padding: 10px;
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .ant-drawer-header {
      min-height: fit-content;
      padding: 16px;

      .custom-header {
        font-size: 1rem;
        font-weight: 600;
      }
    }

    .ant-drawer-body {
      padding: 16px;

      .order-content {
        gap: 10px;

        &.edit-mode .content-invoice {
          display: none;
        }
      }

      .mobile-list-card-body-wrapper {
        row-gap: 0 !important;
      }

      .mobile-list-card-body-item:nth-child(even) {
        padding-bottom: 8px;
        margin-bottom: 8px;
        position: relative;

        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: -100%;
          width: 200%;
          border-bottom: 1px solid ${(props) => props.theme.inputAddonBg};
        }

        &:last-child {
          padding-bottom: 0;
          margin-bottom: 0;

          &::after {
            display: none;
          }
        }
      }
    }

    .ant-drawer-footer {
      padding: 16px;

      .footer-container {
        justify-content: flex-start;
        overflow-x: auto;
        flex-wrap: nowrap;
        -webkit-overflow-scrolling: touch;

        &::before {
          content: '';
          margin-left: auto;
        }

        &::-webkit-scrollbar {
          height: 4px;
        }

        > * {
          flex: 0 0 auto;
        }
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.xs}px) {
    .ant-drawer-footer .footer-container {
      flex-wrap: wrap;
      overflow-x: visible;
      justify-content: flex-end;
      gap: 10px;

      &::before {
        display: none;
      }

      > .ant-btn {
        padding-left: 5px;
        padding-right: 5px;
      }
    }
  }
`;
